// @ts-nocheck
import { dapiFetchCache, dapiFetch, IDapiRequest } from '@origin-digital/daxi';

import {
  ISearchAiDataResponse,
  ISearchAiFeedbackDataResponse,
  ISearchAiFeedbackRequestDto,
  ISearchAiFeedbackResponseDto,
} from '../models';

/*
 * This code has been generated from an OpenAPI spec.
 */

export interface IFeedbackRequest extends ISearchAiFeedbackRequestDto {
}

/**

 */
export const feedback = async (baseUrl: string, data: IFeedbackRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<ISearchAiFeedbackDataResponse> => {
    try {
        const method = 'POST';
        const url = baseUrl + feedbackUrl();
        const queryString = '';
        const body: any = data;

        if (ttlInMin > 0) {
          const fetchOptions = { method, body, authorization, ttlInMin };
          const response = await dapiFetchCache<ISearchAiFeedbackDataResponse>(url + queryString, fetchOptions);
          return response.data as ISearchAiFeedbackDataResponse;
        }

        const fetchOptions = { method, body, authorization };
        const response = await dapiFetch<ISearchAiFeedbackDataResponse>(url + queryString, fetchOptions);
        return response.data as ISearchAiFeedbackDataResponse;
    } catch (error) {
        error.newRelic = `'POST: ${ feedbackUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the feedback endpoint url that substitutes in given url params.
  */
const feedbackUrl = () => {
    return '/api/search-ai/feedback';
};


export interface ISearchAiRequest {
  q: string;
}

/**

 */
export const searchAi = async (baseUrl: string, data: ISearchAiRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<ISearchAiDataResponse> => {
    try {
        const method = 'GET';
        const url = baseUrl + searchAiUrl();
        const params: any = data;
        const queryString = '?' + ['q',]
        .filter(k => params[k] !== undefined)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');

        if (ttlInMin > 0) {
          const fetchOptions = { method, authorization, ttlInMin };
          const response = await dapiFetchCache<ISearchAiDataResponse>(url + queryString, fetchOptions);
          return response.data as ISearchAiDataResponse;
        }

        const fetchOptions = { method, authorization };
        const response = await dapiFetch<ISearchAiDataResponse>(url + queryString, fetchOptions);
        return response.data as ISearchAiDataResponse;
    } catch (error) {
        error.newRelic = `'GET: ${ searchAiUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the searchAi endpoint url that substitutes in given url params.
  */
const searchAiUrl = () => {
    return '/api/search-ai';
};

